import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import "./wizard.css";
import { IconV2 } from "../../../icon_v2";
var StepState;
(function (StepState) {
    StepState["Active"] = "active";
    StepState["Completed"] = "completed";
    StepState["Inactive"] = "inactive";
})(StepState || (StepState = {}));
export const WizardV2 = ({ steps, currentStep, onStepChange, className = "", }) => {
    const baseClasses = {
        container: "relative",
        stepWrapper: "relative mb-1 last:mb-0",
        stepContent: "relative flex py-3 pl-6",
        contentWrapper: "w-full",
    };
    // Animation classes
    const animationClasses = {
        fadeIn: "fadeIn",
        scaleIn: "scaleIn",
        slideInRight: "slideInRight",
        slideInUp: "slideInUp",
    };
    // Step indicator classes
    const stepIndicatorClasses = {
        line: {
            base: "border-l-2",
            active: "border-blue-500 dark:border-[#00213B]",
            inactive: "border-gray-200 dark:border-gray-700",
        },
        dotContainer: {
            base: "absolute -left-[12px] top-[13px]",
            outer: "h-[22px] w-[22px] rounded-full bg-white dark:bg-gray-800 flex items-center justify-center",
            inner: {
                base: "h-[14px] w-[14px] rounded-full",
                active: "bg-blue-500 dark:bg-[#00213B]",
                inactive: "bg-gray-200 dark:bg-gray-700",
            },
        },
        checkmark: "absolute right-0 top-1/3 transform -translate-y-1/2 h-4 w-4 flex items-center justify-center rounded-full bg-green-500 dark:bg-green-600 text-white text-xs",
    };
    // Content classes
    const contentClasses = {
        activeBackground: "absolute inset-0 rounded-lg bg-blue-50 dark:bg-[#00213B]",
        button: {
            base: "w-full text-left",
            hover: "hover:text-blue-600 dark:hover:text-blue-400",
        },
        stepLabel: {
            base: "text-sm font-medium",
            active: "text-blue-600 dark:text-blue-300",
            inactive: "text-gray-500 dark:text-gray-400",
        },
        title: {
            base: "mt-0.5 block text-lg font-semibold",
            active: "text-gray-900 dark:text-white",
            completed: "text-gray-500 dark:text-gray-400",
            inactive: "text-gray-500 dark:text-gray-400",
        },
        description: {
            base: "mt-0.5 block text-sm",
            active: "text-gray-600 dark:text-gray-200",
            completed: "text-gray-500 dark:text-gray-400",
            inactive: "text-gray-500 dark:text-gray-400",
        },
        panel: {
            wrapper: "mt-3 pr-6",
        },
    };
    const getStepState = (index) => {
        if (index === currentStep)
            return "active";
        if (index < currentStep)
            return "completed";
        return "inactive";
    };
    return (_jsx("div", { className: `${baseClasses.container} ${className}`, children: steps.map((step, index) => {
            const state = getStepState(index);
            const isActive = state === StepState.Active;
            const isCompleted = state === StepState.Completed;
            return (_jsxs("div", { className: baseClasses.stepWrapper, children: [isActive && (_jsx("div", { className: `${contentClasses.activeBackground} ${animationClasses.fadeIn}` })), isCompleted && (_jsx("span", { className: stepIndicatorClasses.checkmark, children: _jsx(IconV2, { type: "fa", icon: {
                                icon: ["far", "check"],
                                fixedWidth: true,
                            } }) })), _jsxs("div", { className: `${baseClasses.stepContent} ${stepIndicatorClasses.line.base} ${isActive
                            ? stepIndicatorClasses.line.active
                            : stepIndicatorClasses.line.inactive}`, children: [_jsx("div", { className: stepIndicatorClasses.dotContainer.base, children: _jsx("div", { className: stepIndicatorClasses.dotContainer.outer, children: _jsx("div", { className: `${stepIndicatorClasses.dotContainer.inner.base} ${isActive
                                            ? stepIndicatorClasses.dotContainer.inner.active
                                            : stepIndicatorClasses.dotContainer.inner.inactive} ${animationClasses.scaleIn}` }) }) }), _jsxs("div", { className: `${baseClasses.contentWrapper} ${animationClasses.slideInRight}`, children: [_jsxs("button", { className: `${contentClasses.button.base} ${!isActive ? contentClasses.button.hover : ""}`, onClick: () => onStepChange === null || onStepChange === void 0 ? void 0 : onStepChange(index), children: [_jsxs("span", { className: `${contentClasses.stepLabel.base} ${isActive
                                                    ? contentClasses.stepLabel.active
                                                    : contentClasses.stepLabel.inactive}`, children: ["Step ", step.id] }), _jsx("span", { className: `${contentClasses.title.base} ${isActive
                                                    ? contentClasses.title.active
                                                    : isCompleted
                                                        ? contentClasses.title.completed
                                                        : contentClasses.title.inactive}`, children: step.title }), step.description !== undefined && (_jsx("span", { className: `${contentClasses.description.base} ${isActive
                                                    ? contentClasses.description.active
                                                    : isCompleted
                                                        ? contentClasses.description.completed
                                                        : contentClasses.description.inactive}`, children: step.description }))] }), isActive && step.content !== undefined && (_jsx("div", { className: `${contentClasses.panel.wrapper} ${animationClasses.slideInUp}`, children: step.content }))] })] })] }, step.id));
        }) }));
};
export default WizardV2;
